//import plupload from 'plupload';
const $ = require('jquery');

export default class Uploader {
    constructor() {
        this.uploaders = [];
        let $this = this;

        $(document).on('click', '.rbm_js_form_remove_file', function () {
            "use strict";
            let uid = $(this).data('uid');
            for (let i = 0; i < $this.uploaders.length; i++) {
                if ($this.uploaders[i].uid === uid) {
                    $this.uploaders[i].removeFile($(this).attr('id'));
                }
            }
            $(this).remove();
        });

    }

    start(container){
        for (let i = 0; i < this.uploaders.length; i++) {
            if (this.uploaders[i].settings.multipart_params.container === container) {
                this.uploaders[i].start();
            }
        }
    }

    addUploader(container, callback, filelocator){
        let upContainer = $(container);
        if (upContainer.length) {
            try{
                plupload
            }catch(e){
                $('head').append('<script src="/includes/jscripts/plupload/plupload.full.min.js"></script>');
            }
			
            let fileList = $(upContainer).find(".rbm_form_file_list")[0]; // Контейнер, для хранения списка файлов
            let button = $(upContainer).find(".rbm_form_file_but")[0]; // Кнопка для выбора файлов
			
			let formName = 'default';
			try
			{
				formName = upContainer.find('.rbm_js_btn_send_msg').data('msg_name');
			}catch(e){}
			
			
            let    uploader = new plupload.Uploader({
                    runtimes: 'html5,flash,silverlight,html4',
                    browse_button: button,
                    container: upContainer[0],
                    multi_selection: false,
                    url: filelocator || `/includes/modules/form/upload_form_file.php?form_name=${formName}`,
                    max_file_size: '50mb',

                    filters: [{
                        title: "Table files",
                        extensions: "xls,xlsx"
                    },
                        {
                            title: "Documents files",
                            extensions: "doc,docx,rtf,pdf,txt"
                        },
                        {
                            title: "Image files",
                            extensions: "jpg,jpeg,png,tiff,bmp,ico,gif,psd"
                        },
                        {
                            title: "Zip files",
                            extensions: "zip,rar,gz,tar,tgz"
                        }
                    ],
                    init: {
                        FilesAdded: function (up, files) {
                            plupload.each(files, function (file) {
                                fileList.innerHTML += '<div class="rbm_js_form_remove_file attached-file icon_check cursor-pointer" data-uid="' + up.uid + '"  id="' + file.id + '"><span>' + file.name + ' (' + plupload.formatSize(file.size) + ') <b></b> <span class="delete-file btn btn-close"></span></span> </div>';
                            });
                        },
                        FileUploaded: function (up, file, response) {
							let files = $(button).closest('form, .form').find('[name="user_data_file"]');
							if(files.length){
								files.remove();
							}
                            $(button).closest('form, .form').append(
                                '<input type="hidden" name="user_data_file" value="' + response.response + '">'
                            );
                        },
                        UploadProgress: function (up, file) {
                            document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = '<span>' + file.percent + "%</span>";
                        },
                        UploadComplete: function (up , files) {
                            fileList.innerHTML = "";
                            $(button).show();
                            if(callback){
                                callback(container, files, up);
                            }
                        },
                        Error: function (up, err) {
                            let mes = "\nError upload #" + err.code + ": " + err.message;
                        }
                    }
                });

            uploader.init();
            uploader.settings.multipart_params = {
                container: container
            };

            this.uploaders.push(uploader);
        }
    }
}